import useUserDotComInit from "@hooks/userDotCom/useUserDotComInit";
import { Outlet } from "react-router";
import useUpdateUserDotCom from "@hooks/userDotCom/useUpdateUserDotCom";

export default function UserDotCom() {
  useUserDotComInit();
  useUpdateUserDotCom();
  return <Outlet />;
}
